<template>
  <div class="col-12">
       

            <div class="input-content no-border">
                <input v-model="search" placeholder="Search by program name" type="text" @keyup="searchCourses()" />
            </div>

            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead >
                        <th v-for="(header, index) in table_headers" :key="index">
                           <a v-if="header == 'Created on' " class="pointer" @click="ascending = !ascending">{{header}}<img class="sort-icon" src="../../../assets/images/icons/solid/vector_arrow.svg"></a> 
                           <a v-else>{{header}}</a> 
                        </th>
                    
                    </thead>
                    <tbody>
                        <tr v-for="(course, index) in table_body_data" :key="index">
                            <td>{{ course.id }} </td>
                            <td>
                                <div>
                                    <router-link tag="a" :to="{ name : 'sme.courses.edit', params : { id : course.id } }">
                                        <strong>{{ course.name }}</strong>
                                    </router-link>
                                    </div>
                                <div>{{ course.description }}</div>
                            </td>
                            <td>
                                 <div v-if="course.in_class" class="m-0 progress-icon approved"></div>
                                  <div v-else class="m-0 progress-icon disapproved"></div>
                            </td>
                            <td>{{course.notes}}</td>
                            <td>
                                <!-- modal with agencies -->
                                <div class="trigger-hidden-content ml-1 d-inline-block">
                                    <span class=" button">

                                        <strong>{{ course.organizations.length }}</strong>

                                    </span>
                                    <div class="hidden-content hc-right hidden-content-table">
                                        <div>
                                            <div class="h4">Agencies</div>

                                            <table class="table table-bordered">
                                                <thead>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="organization in course.organizations">
                                                        <td>{{ organization.id }}</td>
                                                        <td>
                                                            <div><strong>{{ organization.name }}</strong></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>	
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <!-- modal with modules -->
                                <div class="trigger-hidden-content ml-1 d-inline-block">
                                    <span class=" button">

                                        <strong>{{ course.modules.length}}</strong>
                                        
                                    </span>
                                    <div class="hidden-content hc-right hidden-content-table">
                                        <div>
                                            <div class="h4">Modules</div>
                                            <table class="table table-bordered">
                                                <thead>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="module in course.modules">
                                                        <td><button  @click="openInNewTab(module.id, 'module')">{{ module.id }}</button></td>
                                                        <td>
                                                            <div><strong>{{ module.title }}</strong></div>
                                                            <div>{{ module.notes }}</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>	
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>{{ course.created_at }}</td>
                            <td v-if="view == 'sme'">
                                <div class="trigger-hidden-content ml-1 d-inline-block">
                                    <span class=" button">
                                        <img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
                                    </span>
                                    <div class="hidden-content hc-right-bottom">
                                        <div>
                                            <ul class="list-unstyled text-left">
                                                <!-- <li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="showModalDuplicate(course)">
                                                    <img width="12" class="mr-2" src="../../../assets/images/icons/solid/clone.svg">
                                                    <span> Duplicate</span>
                                                </li> -->
                                                <li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="showModalDelete(course)">
                                                    <img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
                                                    <span> Delete</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td v-if="view == 'detail'">
							<toggle-button v-model="course.in_organization" 
								:labels="{ checked : 'Remove', unchecked : 'Add'}" :width="100"
								:switchColor="{ checked : red, unchecked : green }"
								:color="{ checked : red, unchecked : green, disabled : '#CCCCCC' }"
								@change="toggleCourse(course)" :sync="true"/>
						</td>
                        </tr>
                    </tbody>
                </table>
                 <b-pagination align="right" :total-rows="pagination_existing_courses.total" v-model="pagination_existing_courses.current_page" 
                :per-page="pagination_existing_courses.per_page" @change="setPageExistingCourses">
                 </b-pagination>
            </div>
        </div>

</template>

<script>
import { EventBus } from './../../../event_bus.js';
export default {
    props:['table_body_data','table_headers','pagination_existing_courses','view'],
    data:function(){
        return{
            search:'',
            red : this.config.COLORS.RED,
			green : this.config.COLORS.GREEN,
            sorted_date:this.table_body_data,
            ascending: true

        }
    },
    watch:{
        ascending: function(val){
            this.table_body_data.sort(function(a, b){
                    var aa = a.created_at.split('/').reverse().join(""),
                    bb = b.created_at.split('/').reverse().join("");
                    if(val){
                        return aa > bb ? -1 : (aa < bb ? 1 : 0);
                    }else{
                        return aa < bb ? -1 : (aa > bb ? 1 : 0);
                    }
                   
            })
        }
    },
    mounted: function(){
        EventBus.$on('reset_seach_key', () => {
            this.search = ''
            this.$emit('setPageExistingCourses',{page:1, search:this.search})
		    });
    },
    methods : {
        toggleCourse: function(course){
             this.$emit('toggleCourse', course)
        },
        searchCourses: function(){
            setTimeout( () => {
                this.$emit('searchCourses',this.search)
            },1000)
        },
        showModalDelete: function(course){
            this.$emit('showModalDelete', course)
        },
        showModalDuplicate: function(course){
            var module_view_duplicate = false
            this.$emit('showModalDuplicate',course, module_view_duplicate)
        },
        setPageExistingCourses: function(page){
            console.log(page)
            this.$emit('setPageExistingCourses',{page:page, search:this.search})
        },
        sortTableDate: function(){
            this.sorted_date = this.table_body_data
            this.sorted_date.sort(function(a, b){
                var aa = a.created_at.split('/').reverse().join(""),
                 bb = b.created_at.split('/').reverse().join("");
                return aa < bb ? -1 : (aa > bb ? 1 : 0);
            })
        },
        openInNewTab(objectID, objectType) {
            window.open(
                objectID + "/" + objectType
            );
        },
    }
 
}
</script>



// WEBPACK FOOTER //
// src/components/sme/SharedViews/SMETableView.vue